import { render, staticRenderFns } from "./Magazine.vue?vue&type=template&id=24fe02b2&"
import script from "./Magazine.vue?vue&type=script&lang=js&"
export * from "./Magazine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports